import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PopUpWithButton from "../../../components/popups/PopUpWithButton";
import { selectParchemin } from "../../../slices/parcheminSlice";
import Inhibiteur from "../../../assets/images/room5/Gellules_Medicaments_Enzymes/SideKick.png";
import myTextPopUp from "../../../helpers/textPopUp";


function Room5level4v3() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const parcheminTab = useSelector(selectParchemin);

    const handleClick = (): void => {
        if (parcheminTab.parcheminTab.length > 0) navigate("/chapitre2/room5/levelParchemin");
        else navigate("/chapitre2/room6/level1");
    }
    
    const congratsOne = t("room_five.level_three.congrats.part");
    const congratsTwo = t("room_five.level_three.congrats.finally");

    return (
        <div className="containerNextRoom" style={{ backgroundColor: "#BEDDFA" }}>
            <div className="container-elements">
                <div className="container-img">
                    <img src={Inhibiteur} alt="" />
                </div>

                <PopUpWithButton
                    title={`${myTextPopUp.room5[21].content}</br> ${(parcheminTab.parcheminTab.length > 0) ? congratsOne : congratsTwo}`}
                    icon={!(parcheminTab.parcheminTab.length > 0)}
                    button={(parcheminTab.parcheminTab.length > 0) ? myTextPopUp.room5[12].button : undefined}
                    style={{ borderRadius: "30px" }}
                    styleBtn={{ backgroundColor: "#055C5C", color: "white" }}
                    click={e => handleClick()}
                />
            </div>
        </div>
    )
}

export default Room5level4v3;
